import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import SecureRoute from "shared/services/AuthDecorator/SecureRoute";
import Loader from "shared/uikit/Loader";

import { routes } from "./constants";

const BasicLayout = lazy(() => import("shared/templates/Layouts/BasicLayout"));

const DiscoverPage = lazy(() => import("./Pages/Discover"));
const LaunchPage = lazy(() => import("./Pages/Launch"));
const MarketplacePage = lazy(() => import("./Pages/Marketplace"));
const RealEstatePage = lazy(() => import("./Pages/RealEstate"));
const ProfileDashboardPage = lazy(() => import("./Pages/Profile/Dashboard"));
const EditProfilePage = lazy(() => import("./Pages/Profile/Edit"));
const WalletDashboardPage = lazy(() => import("./Pages/Wallet/Dashboard"));
const WalletEditRegistrationPage = lazy(() => import("./Pages/Wallet/Edit"));
const TokenIssuancePage = lazy(() => import("./Pages/TokenIssuance"));
const LogoutPage = lazy(() => import("./Pages/Logout"));

const MemberRoutes = () => {
	const getPublicRoutes = () => [
		<Route
			key={routes.launches.getElementKey()}
			path={routes.launches.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<LaunchPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.discover.getElementKey()}
			path={routes.discover.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<DiscoverPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.market.getElementKey()}
			path={routes.market.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<MarketplacePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.marketplace.realEstate.getElementKey()}/id`}
			path={`${routes.marketplace.realEstate.getPath()}/:id`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<RealEstatePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.tokenIssuance.getElementKey()}/step`}
			path={`${routes.tokenIssuance.getPath()}/:step?`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<TokenIssuancePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.profile.getElementKey()}/username`}
			path={`${routes.profile.getPath()}/:username`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<ProfileDashboardPage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.profile.getElementKey()}/username/edit`}
			path={`${routes.profile.getPath()}/:username/edit`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<EditProfilePage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.wallet.getElementKey()}/username`}
			path={`${routes.wallet.getPath()}/:username`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<WalletDashboardPage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.wallet.getElementKey()}/username/edit`}
			path={`${routes.wallet.getPath()}/:username/edit`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<WalletEditRegistrationPage />
				</Suspense>
			}
		/>
	];

	const getSecuredRoutes = () => [
		<Route
			key={routes.logout.getElementKey()}
			path={routes.logout.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<LogoutPage />
				</Suspense>
			}
		/>
	];

	return [
		<Route
			key="member-routes-root"
			element={
				<Suspense fallback={<Loader wrapper />}>
					<BasicLayout />
				</Suspense>
			}
		>
			{getPublicRoutes()}
			<Route element={<SecureRoute roles={[]} />}>{getSecuredRoutes()}</Route>
		</Route>
	];
};

export default MemberRoutes;
